import { grid, maxWidthContainer, minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { createGlobalStyle, css } from 'styled-components';

import { MODAL_HEIGHT_CSS_VAR } from '../constants/cssVariables';

export interface ModalGlobalStylesProps {
  contentClassNames: ReactModal.Classes;
  overlayClassNames: ReactModal.Classes;
  tranistionMS: number;
}

export const ModalGlobalStyles = ({
  contentClassNames,
  overlayClassNames,
  tranistionMS,
}: ModalGlobalStylesProps) => createGlobalStyle`
    .ReactModal__Body--open {
      overflow: hidden;
    }
  
    .${overlayClassNames.base} {
      ${grid}
      ${maxWidthContainer}
  
      bottom: 0;
      height: 100%;
      left: 0;
      opacity: 0;
      padding: 0;
      position: fixed;
      right: 0;
      top: 0;
      transition: opacity ${tranistionMS}ms ease 0s;
      width: 100%;
      z-index: 600;
  
      &::before {
        background-color: var(--neutral-black-base);
        opacity: 0.4;
        content: '';
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
    }
  
    .${overlayClassNames.afterOpen} {
      opacity: 1;
    }
  
    .${overlayClassNames.beforeClose} {
      opacity: 0;
    }
  
    .${contentClassNames.base} {
      background: var(--neutral-white-base);
      bottom:0;
      box-sizing: border-box;
      display: flex;
      grid-column: 1 / -1;
      height: 100vh;
      height: var(${MODAL_HEIGHT_CSS_VAR});
      left: 0;
      opacity: 0;
      overflow: hidden;
      position: relative;
      transform: scale(0.8);
      transition: transform ${tranistionMS}ms linear, opacity ${tranistionMS}ms;
      width: 100%;
  
      ${mediaQuery(
        { min: minBreakpoints.M },
        css`
          align-self: center;
          border-radius: ${pxToRem(10)};
          grid-column: 3 / -3;
          max-height: ${pxToRem(800)};
        `,
      )}
  
      ${mediaQuery(
        { min: minBreakpoints.L },
        css`
          grid-column: 4 / -4;
          max-height: ${pxToRem(772)};
        `,
      )}
    }
  
    .${contentClassNames.afterOpen} {
      opacity: 1;
      transform: scale(1);
    }
  
    .${contentClassNames.beforeClose} {
      opacity: 0;
      transform: scale(1);
    }
  `;

export const modalWrapper = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
